import React from "react";

type Props = {
    width: number;
    height: number;
    zoom?: number;
    editable?: boolean;
    isFullscreen?: boolean;
    canvasRef?: React.RefObject<HTMLCanvasElement>;
    validationBanner?: React.ReactNode;
    actionBar?: React.ReactNode;
    children?: React.ReactNode;
    stageWrapClassName?: string;
    stageShellClassName?: string;
    stageShellStyle?: React.CSSProperties;
};

export default function AutomationTreeCanvas({
    width,
    height,
    zoom = 1,
    editable = true,
    isFullscreen = false,
    canvasRef,
    validationBanner,
    actionBar,
    children,
    stageWrapClassName = "",
    stageShellClassName = "",
    stageShellStyle,
}: Props) {
    const wrapClassName = `v2at-stage-wrap ${isFullscreen ? "is-fullscreen" : ""} ${stageWrapClassName}`.trim();
    const shellClassName = `v2at-stage-shell ${stageShellClassName}`.trim();
    const mergedStageShellStyle: React.CSSProperties = isFullscreen
        ? { height: "100vh", maxHeight: "100vh" }
        : editable
            ? { ...(stageShellStyle || {}) }
            : { paddingTop: 0, ...(stageShellStyle || {}) };
    return (
        <div className={wrapClassName}>
            {validationBanner || null}
            {editable && actionBar ? <div className="v2at-board-controls">{actionBar}</div> : null}
            <div className={shellClassName} style={mergedStageShellStyle}>
                <div className="v2at-stage-zoom" style={{ width, height }}>
                    <div className="v2at-stage" style={{ width, height, transform: `scale(${zoom})` }}>
                        {canvasRef ? <canvas ref={canvasRef} className="v2at-edges-canvas" /> : null}
                        {children}
                    </div>
                </div>
            </div>
        </div>
    );
}
